import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    layers:[],
    upLoadData:{},
    newDataInfo:{},
    mapOpts:null,
    APP_NAME: 'zxzt_', //用于标识 lacalStorage 存储名称，防止同域名下同名称污染
    usrId:null,
    usrName:null,
  },

  mutations: {
    logout(state){

      localStorage.setItem(state.APP_NAME + 'token',null);
      localStorage.removeItem(state.APP_NAME + 'usrId');
      localStorage.removeItem(state.APP_NAME + 'usrName');
      localStorage.removeItem(state.APP_NAME + 'expTime');

      sessionStorage.removeItem(state.APP_NAME + 'proId');
      sessionStorage.removeItem(state.APP_NAME + 'proName');
      sessionStorage.removeItem(state.APP_NAME + 'baseMappingExtent');

      state.usrId = null;
      state.usrName = null;
      state.proId = null;
      state.proName = null;
      state.layers = [];
      state.upLoadData = {};
      state.newDataInfo = {};

    },
    setToken(state,value){
      localStorage.setItem(state.APP_NAME + 'token', value);
    },
    setThroughSession(state){
      sessionStorage.setItem("throughSession","true");
    },
    newLayer(state,val){
      state.layers.splice(0,0,val) //添加新图层
    },
    removeLayer(state,id){
      state.layers =  state.layers.filter(layer => layer.dataId != id)
    },
    changeLayerIndex(state,val){
      //[new,old]
      const targetRow = this.state.layers.splice(val.oldIndex, 1)[0];
      this.state.layers.splice(val.newIndex, 0, targetRow);
    },
    clearLayers(state){
      state.layers=[];
    },
    initLayerOpts(state,val){
      for(var i=0; i<state.layers.length;i++){
        if(state.layers[i].dataId == val.dataId){
          state.layers[i].options = jQuery.extend(true, {},val.options);
          break;
        }
      } 
    },
    initLayerDisplayData(state,val){
      for(var i=0; i<state.layers.length;i++){
        if(state.layers[i].dataId == val.dataId){
          state.layers[i].displayData = jQuery.extend(true, [], val.displayData) ;
          break;
        }
      } 
    },
    setLayerOpts(state,lyr){
      for(var i=0; i<state.layers.length;i++){
        if(state.layers[i].dataId == lyr.dataId){
          state.layers[i].options = jQuery.extend(true, {},lyr.options);//复制值
          break;
        }
      } 
    },
    setLayerData(state,lyr){
      for(var i=0; i<state.layers.length;i++){
        if(state.layers[i].dataId == lyr.dataId){
          state.layers[i].data = jQuery.extend(true, {},lyr.data);//复制值
          break;
        }
      } 
    },
    setLayerTimeline(state,lyr){
      for(var i=0; i<state.layers.length;i++){
        if(state.layers[i].dataId == lyr.dataId){
          state.layers[i].timeline = jQuery.extend(true, {},lyr.timeline);//复制值
          break;
        }
      } 
    },
    setLayerVisible(state,val){
      for(var i=0; i<state.layers.length;i++){
        if(state.layers[i].dataId == val.layerId){
          state.layers[i].visible = val.visible;
          break;
        }
      } 
    },
    setLayerDisplayData(state,lyr){
      for(var i=0; i<state.layers.length;i++){
        if(state.layers[i].dataId == lyr.dataId){
          state.layers[i].displayData = $.extend(true, {},lyr.displayData);//复制值
          break;
        }
      } 
    },
    setLayerPatternType(state,val){
      for(var i=0; i<state.layers.length;i++){
        if(state.layers[i].dataId == val[0]){
          state.layers[i].patternType = val[1];
          break;
        }
      } 
    },
    newUpData(state,val){
      state.upLoadData =  $.extend(true, [], val);  
    },
    newDataInfo(state,val){
      state.newDataInfo =  $.extend(true, [], val);  
    },
    setUsrId(state, usrId) {
      if(usrId == null) {
        localStorage.removeItem(state.APP_NAME + 'usrId')
      }
      else{
        localStorage.setItem(state.APP_NAME + 'usrId', usrId);
      }
    },
    setUsrName(state, usrName) {
      if(usrName == null) {localStorage.removeItem(state.APP_NAME + 'usrName')}
      else{
        localStorage.setItem(state.APP_NAME + 'usrName', usrName);
      }
    },
    setYunUsrId(state, usrId) {
      if(usrId == null) {localStorage.removeItem(state.APP_NAME + 'yunUsrId')}
      else{
        localStorage.setItem(state.APP_NAME + 'yunUsrId', usrId);
      }
    },
    setYunToken(state, token) {
      if(token == null) {localStorage.removeItem(state.APP_NAME + 'yunToken')}
      else{
        localStorage.setItem(state.APP_NAME + 'yunToken', token);
      }
    },
    setExpTime(state, expTime) {
      if(expTime == null) {localStorage.removeItem(state.APP_NAME + 'expTime')}
      else{
        localStorage.setItem(state.APP_NAME + 'expTime', expTime);
      }
    },
    bulidLayers(state,val){
      state.layers=[];
      state.layers = $.extend(true, [], val);
    },
    setProId(state,val){
     // state.proId = val
      if(val == null) {sessionStorage.removeItem(state.APP_NAME + 'proId')}
      else{
        sessionStorage.setItem(state.APP_NAME + 'proId', val);
      }//同步存储proId至localStorage
    },
    setProName(state,val){
      //state.proName = val
      if(val == null) {sessionStorage.removeItem(state.APP_NAME + 'proName')}
      else{
        sessionStorage.setItem(state.APP_NAME + 'proName', val);
      }  //同步存储proName至localStorage
    },
    setProDateTime(state,val){
      //state.proName = val
      if(val == null) {sessionStorage.removeItem(state.APP_NAME + 'proDateTime')}
      else{
        sessionStorage.setItem(state.APP_NAME + 'proDateTime', val);
      }  //同步存储proName至localStorage
    },
    setBaseMappingExtent(state,val){
      //state.proName = val
      if(val == null) {sessionStorage.removeItem(state.APP_NAME + 'baseMappingExtent')}
      else{
        sessionStorage.setItem(state.APP_NAME + 'baseMappingExtent', val);
      }  
    },
    setMapOpts(state,val){
      state.mapOpts = val
    },
  },
 getters : {
      getToken: (state) => () => {
        return localStorage.getItem(state.APP_NAME + 'token');
      },
      getThroughSession:(state) => () => {
        var throughSession = sessionStorage.getItem("throughSession");
        if(throughSession == "true"){
           return true
        }else{
           return false
        }
      },
      getLayer: (state) => (id) => {
        return state.layers.find(layer => layer.dataId === id)
      },
      getLayers:(state) => () => {
          return state.layers
      },
      getUpData:(state) => () =>{
          return state.upLoadData
      },
      getNewDataInfo:(state) => () =>{
        return state.newDataInfo
      },
      getUsrId:(state) => () =>{
          return localStorage.getItem(state.APP_NAME +'usrId')
      },
      getYunUsrId:(state) => () =>{
        return localStorage.getItem(state.APP_NAME +'yunUsrId')
      },
      getYunToken:(state) => () =>{
        return localStorage.getItem(state.APP_NAME + 'yunToken');
      },
      getUsrName:(state) => () => {
          return localStorage.getItem(state.APP_NAME + 'usrName')
      },
      getExpTime:(state) => () => {
          return localStorage.getItem(state.APP_NAME + 'expTime')
      },
      getProId:(state) => () => {
        // if (!state.proId) {
        //   state.proId = sessionStorage.getItem(state.APP_NAME + 'proId')
        // }
          return sessionStorage.getItem(state.APP_NAME + 'proId')
      },
      getProName:(state) => () => {
        // if (!state.proName) {
        //   state.proName = sessionStorage.getItem(state.APP_NAME + 'proName')
        // }
          return sessionStorage.getItem(state.APP_NAME + 'proName')
      },
      getProDateTime:(state) => () => {
        // if (!state.proName) {
        //   state.proName = sessionStorage.getItem(state.APP_NAME + 'proName')
        // }
          return sessionStorage.getItem(state.APP_NAME + 'proDateTime')
      },
      getBaseMappingExtent:(state) => () => {
          return sessionStorage.getItem(state.APP_NAME + 'baseMappingExtent')
      },
      getMapOpts:(state) => () =>{
          return state.mapOpts
      },
      getUUID:(state) => () =>{
        var d = new Date().getTime();
        if (window.performance && typeof window.performance.now === "function") {
            d += performance.now(); //use high-precision timer if available
        }
        var uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
            var r = (d + Math.random() * 16) % 16 | 0;
            d = Math.floor(d / 16);
            return (c == 'x' ? r : (r & 0x3 | 0x8)).toString(16);
        });
        return uuid;
     },

  },
  actions: {

  }
})
